var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7805 39C20.7714 33.9844 29.8734 21.8281 29.8734 15C29.8734 6.71875 23.183 0 14.9367 0C6.6904 0 0 6.71875 0 15C0 21.8281 9.10206 33.9844 13.093 39C14.0498 40.1953 15.8236 40.1953 16.7805 39ZM14.9367 10C16.2572 10 17.5236 10.5268 18.4573 11.4645C19.3911 12.4021 19.9156 13.6739 19.9156 15C19.9156 16.3261 19.3911 17.5979 18.4573 18.5355C17.5236 19.4732 16.2572 20 14.9367 20C13.6162 20 12.3498 19.4732 11.4161 18.5355C10.4824 17.5979 9.95781 16.3261 9.95781 15C9.95781 13.6739 10.4824 12.4021 11.4161 11.4645C12.3498 10.5268 13.6162 10 14.9367 10Z",
    fill: "#FFFEF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.8734,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdressIcon);
export default __webpack_public_path__ + "static/media/adress-icon.45e50ead116df43cce1a550fe32c55ed.svg";
export { ForwardRef as ReactComponent };